<div class="field">
    @if (label()) {
        <label [for]="inputId()">{{ label() }}</label>
    }
    <cl-textarea [inputId]="inputId()" [formControl]="control()" [placeholder]="placeholder()" [rows]="rows()" />
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
